<main>
  <loading-overlay [isLoading]="isLoading > 0" />
  <header>
    <div class="flex gap-[2rem]">
      <h1>
        {{ 'Delivery_Note_Details_Title' | translateWF: 'Delivery Note' }}:
        {{ deliveryNote ? deliveryNote.number : ('Delivery_Note_Details_Title_New' | translateWF: 'New Delivery Note') }}
      </h1>
    </div>
    <div class="buttons">
      <p-button
        *ngIf="deliveryNote ? deliveryNote.createdDate : true"
        [label]="'Save' | translateWF: 'Save'"
        (click)="save()"
        [disabled]="!canEdit() || listWorkOrderSelected().length <= 0"
      />
      <p-button [label]="'Cancel' | translateWF: 'Cancel'" variant="outlined" (click)="cancel()" />
    </div>
  </header>

  <div class="content">
    <form [formGroup]="deliveryNoteForm" class="col">
      <p-panel [header]="'Delivery_Note_Details_General_Information' | translateWF: 'General Information'">
        <p-card>
          <div class="grid-auto-2">
            <div class="form-box">
              <label for="">{{ 'Delivery_Note_Details_Manufacturer' | translateWF: 'Client' }}</label>
              <p-autocomplete
                fluid=""
                class="w-full"
                formControlName="client"
                [dropdown]="true"
                [suggestions]="clientsToDisplay"
                optionLabel="name"
                (completeMethod)="searchClient($event)"
              />
            </div>
            <div class="form-box">
              <label for="">{{
                'Delivery_Note_Details_Client_Document_Reference'
                  | translateWF
                    : 'Client Document
                Reference'
              }}</label>
              <input type="text" class="p-inputtext p-component w-full" [formControl]="clientDocumentReference" />
            </div>
            <div class="form-box">
              <label for="issuedDate">{{ 'Delivery_Note_Details_Issued_Date' | translateWF: 'Issued Date' }}</label>
              <p-calendar fluid="" class="w-full" inputId="issuedDate" formControlName="issuedDate" [showIcon]="false" dateFormat="yy-mm-dd" [disabled]="!canEdit()"> </p-calendar>
            </div>
            <div class="form-box">
              <label for="createdDate">{{ 'Delivery_Note_Details_Created_Date' | translateWF: 'Created Date' }}</label>

              <p-calendar fluid="" class="w-full" inputId="createdDate" formControlName="createdDate" [showIcon]="false" dateFormat="yy-mm-dd" [disabled]="true"> </p-calendar>
            </div>
          </div>
        </p-card>
      </p-panel>

      <p-panel [header]="'DeliveryNoteDetails.WorkOrderRelated' | translateWF: 'Work Order Related'">
        <ng-template pTemplate="icons">
          <p-autocomplete
            fluid=""
            class="w-full"
            formControlName="workOrder"
            [dropdown]="true"
            [suggestions]="workOrdersToDisplay"
            optionLabel="orderNumber"
            (completeMethod)="searchWorkOrder($event)"
            (onSelect)="addWorkOrderAtList($event)"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="listWorkOrderSelected()">
            <ng-template #header>
              <tr>
                <th>{{ 'DeliveryNoteDetails.TableWorkOrderNumber' | translateWF: 'Work Order Number' }}</th>
                <th>{{ 'DeliveryNoteDetails.TableClient' | translateWF: 'Client' }}</th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-WO let-index="rowIndex">
              <tr class="text-center">
                <td>
                  {{ WO.orderNumber }}
                </td>
                <td>
                  {{ WO.customer?.name || '' }}
                </td>
                <td>
                  <p-button
                    icon="pi pi-trash"
                    variant="outlined"
                    [label]="'Delete' | translateWF: 'Delete'"
                    severity="danger"
                    size="small"
                    (click)="deleteWorkOrderAtList(index)"
                  />
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-card>
      </p-panel>

      <p-panel [header]="'Delivery_Note_Details_Items' | translateWF: 'Items'">
        <p-card data-variant="compact">
          <p-table [value]="formArrayItems.controls" [scrollable]="true" scrollHeight="400px">
            <ng-template #header>
              <tr>
                <th rowspan="8" style="width: 16rem">{{ 'Delivery_Note_Details_Item_Code' | translateWF: 'Item' }}</th>
                <th>{{ 'DeliveryNoteDetails.WorkOrder' | translateWF: 'Work Order' }}</th>
                <th>{{ 'Delivery_Note_Details_Quantity' | translateWF: 'Quantity' }}</th>
                @if (canEdit()) {
                  <th>{{ 'Actions' | translateWF: 'Actions' }}</th>
                }
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item let-index="rowIndex" formArrayName="items">
              <tr class="cursor-pointer" [formGroupName]="index">
                <td pTooltip="{{ item.get('description')?.value }}" tooltipPosition="top">
                  <b>
                    {{ item.get('itemCode')?.value }}
                  </b>
                  <p>
                    {{ item.get('itemDescription')?.value }}
                  </p>
                </td>
                <td>
                  <p-dropdown
                    appendTo="body"
                    fluid=""
                    class="w-full"
                    formControlName="selectedWorkOrder"
                    [options]="getAvailableWorkOrdersForItem(item.get('itemCode')?.value)"
                    optionLabel="orderNumber"
                    placeholder="{{ 'DeliveryNoteDetails.SelectWorkOrder' | translateWF: 'Select WO' }}"
                    [disabled]="!canEdit()"
                  >
                  </p-dropdown>
                </td>

                <td>
                  <p-inputnumber class="w-full" formControlName="quantity" [showButtons]="false" [disabled]="!canEdit()" />
                </td>
                @if (canEdit()) {
                  <td>
                    <p-button
                      icon="pi pi-trash"
                      variant="outlined"
                      [label]="'Delete' | translateWF: 'Delete'"
                      severity="danger"
                      size="small"
                      (click)="deleteItemArrayForm(index)"
                    />
                  </td>
                }
              </tr>
            </ng-template>

            <ng-template pTemplate="footer">
              @if (listWorkOrderSelected().length > 0) {
                <tr>
                  <td colspan="4">
                    <div>
                      <p-dropdown
                        appendTo="body"
                        [formControl]="fabricSelection"
                        [options]="itemMastersForDropdown"
                        optionLabel="displayLabel"
                        optionValue="itemCode"
                        placeholder="{{ 'DeliveryNoteDetails.SelectItem' | translateWF: 'Select an item to add' }}"
                        (onChange)="addItemMaster($event.value)"
                      >
                      </p-dropdown>
                    </div>
                  </td>
                </tr>
              }

              <tr>
                <td>
                  <p>{{ 'Delivery_Note_Details_Total_Quantities' | translateWF: 'Total Quantities' }}</p>
                </td>
                <td>
                  <p-inputgroup>
                    <p-inputnumber [formControlName]="'totalQuantitiesLbs'" minFractionDigits="2" maxFractionDigits="2"></p-inputnumber>
                    <p-inputGroupAddon> Lbs </p-inputGroupAddon>
                  </p-inputgroup>
                  <br />
                  <p-inputgroup>
                    <p-inputnumber [formControlName]="'totalQuantitiesKgs'" minFractionDigits="2" maxFractionDigits="2" />
                    <p-inputGroupAddon> Kgs </p-inputGroupAddon>
                  </p-inputgroup>
                </td>
                <td colspan="2"></td>
              </tr>
            </ng-template>
          </p-table>
        </p-card>
      </p-panel>

      <p-panel [header]="'Purchase_Order_Details_Files' | translateWF: 'Files'">
        <p-card>
          @if (!deliveryNote) {
            <p>{{ 'Invoice_Details_To_Upload_Files' | translateWF: 'To upload files, save delivery note first.' }}</p>
          } @else {
            <div class="files-content">
              @if (canEdit()) {
                <div class="drag-and-drop">
                  <ngx-file-drop [showBrowseBtn]="false" (onFileDrop)="uploadFiles($event)">
                    <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                      <div class="drop-content">
                        <p class="title">
                          <b>{{ 'Purchase_Order_Details_Drag_And_Drop' | translateWF: 'Drag and drop' }}</b>
                        </p>
                        <p class="or-text">{{ 'Purchase_Order_Details_Or' | translateWF: 'or' }}</p>
                        <p-button
                          [label]="'Purchase_Order_Details_Browse_File' | translateWF: 'Browse File'"
                          icon="pi pi-download"
                          variant="outlined"
                          (onClick)="openFileSelector()"
                        ></p-button>
                      </div>
                    </ng-template>
                  </ngx-file-drop>
                </div>
              }
              <div class="uploaded-files">
                <div class="under__line">
                  <h4>{{ 'Purchase_Order_Details_Uploaded' | translateWF: 'Uploaded' }}</h4>
                </div>
                <p-scrollpanel [style]="{ width: '100%', height: '250px' }">
                  <ul>
                    @for (file of getAllFiles(); track $index) {
                      <li class="mb-5">
                        <div class="info">
                          <p class="type">
                            <b>{{ file.name.split('.').pop() }}</b>
                            @if (file.isPending) {
                              <span class="ml-2 text-xs text-orange-500">(Pending)</span>
                            }
                          </p>
                          @if (file.presignedUrl) {
                            <a (click)="viewFile(file.presignedUrl)" class="file-name">{{ getFileName(file.name) }}</a>
                          } @else {
                            <span class="file-name">{{ getFileName(file.name) }}</span>
                          }
                        </div>
                        @if (canEdit()) {
                          <div class="actions">
                            <p-button icon="pi pi-trash" variant="text" (click)="deleteFile($index, file)" />
                          </div>
                        }
                        `
                      </li>
                    } @empty {
                      <li>
                        <p>{{ 'Purchase_Order_Details_No_Files_Uploaded' | translateWF: 'No files uploaded' }}</p>
                      </li>
                    }
                  </ul>
                </p-scrollpanel>
              </div>
            </div>
          }
        </p-card>
      </p-panel>
    </form>
  </div>
</main>
